export default __webpack_public_path__ + "images/AskHelp.v-5bd51ab60cd222252bc58998e917e4df.png";